export default "__VITE_PUBLIC_ASSET__2e8f2263__"